import Loader from "../../components/Loader";
import SlideToggle from "../SlideToggle";
import { Link } from "react-router-dom";

const DeviceInfo = (props) => {

    return (
        <div>
            <div className='device tablet:p-8 mobile:p-3'>
                <div className='tablet:p-8 mobile:p-3 min-h-[80vh] mb-6'>
                    {
                        props.loading ?
                            <Loader /> :
                            <div className='device'>
                                <div className='min-h-[80vh]'>

                                    <div className="input-border flex flex-wrap items-center justify-between text-3xl p-2 w-full">
                                        <div className='items-center mb-6 laptop:w-1/2 tablet:w-full mobile:'>
                                            <input
                                                placeholder='Device ID'
                                                className='text-3xl p-2 outline-none hide-input-background laptop:w-1/2 tablet:w-full mobile:w-full'
                                                type="text"
                                                name='device_id'
                                                disabled={true}
                                                value={props.device?.device_id ? props.device?.device_id : ""}
                                                onChange={props.updateDevice} />
                                        </div>
                                        <div className="flex flex-nowrap items-center justify-center mb-6">
                                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color mt-2' htmlFor="active">Active</label>
                                            <SlideToggle disabled={true} setOptions={props.setDeviceData} options={props.device} id={"active"} />
                                        </div>
                                    </div>
                                    {
                                        props.loading &&
                                        <Loader />
                                    }
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap tablet:w-4/12 mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-nowrap items-center'>
                                                <label className='w-4/12 text-base input-label-color' htmlFor="location">Location</label>
                                                <input
                                                    placeholder='Location'
                                                    className='p-1 w-full mr-2 text-base input-color outline-none hide-input-background p-2'
                                                    type="text"
                                                    name="location"
                                                    value={props.device?.location ? props.device?.location : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.location &&
                                                    <p className='text-red text-xs'>{props.error.location}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap tablet:w-5/12 mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-nowrap items-center'>
                                                <label className='w-4/12 text-base input-label-color' htmlFor="location">Device Name</label>
                                                <input
                                                    placeholder='Device Name'
                                                    className='p-1 w-full mr-2 text-base input-color outline-none hide-input-background p-2'
                                                    type="text"
                                                    name="device_name"
                                                    value={props.device?.device_name ? props.device?.device_name : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.device_name &&
                                                    <p className='text-red text-xs'>{props.error.device_name}</p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-2/5 text-base input-label-color' htmlFor="monitored_distribution_panel">Monitored Distribution / Panel</label>
                                                <input
                                                    placeholder='Monitored Distribution / Panel'
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="text"
                                                    name="monitored_distribution_panel" value={props.device?.monitored_distribution_panel ? props.device?.monitored_distribution_panel : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.monitored_distribution_panel &&
                                                    <p className='text-red text-xs'>{props.error.monitored_distribution_panel}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-3/12 text-base input-label-color' htmlFor="phase_voltage">Phase / Voltage</label>
                                                <select
                                                    className='p-1 mobile:w-1/2 tablet:w-8/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    name="phase_voltage"
                                                    value={props.device?.phase_voltage ? props.device?.phase_voltage : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice}>
                                                    <option value="">No Selection</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                </select>
                                                {
                                                    props.error && props.error.phase_voltage &&
                                                    <p className='text-red text-xs'>{props.error.phase_voltage}</p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap laptop:w-1/3 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="device_type">Device Model</label>
                                                <select
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    name="device_type"
                                                    value={props.device?.device_type ? props.device?.device_type : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice}>
                                                    <option value="">No Selection</option>
                                                    <option value="acurev">Acurev</option>
                                                    <option value="egauge">EGauge</option>
                                                    <option value="virtual">Virtual</option>
                                                </select>
                                                {
                                                    props.error && props.error.device_type &&
                                                    <p className='text-red text-xs'>{props.error.device_type}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap laptop:w-1/3 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-5/12 text-base input-label-color' htmlFor="network_dhcp">Dynamic IP</label>
                                                <input className='mr-3' disabled={true} name="network_dhcp" type="checkbox" checked={props.device?.network_dhcp} onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.network_dhcp &&
                                                    <p className='text-red text-xs'>{props.error.network_dhcp}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap laptop:w-1/3 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-3/12 text-base input-label-color' htmlFor="ip_address">IP Address</label>
                                                <input
                                                    placeholder='IP Address'
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="text"
                                                    name="ip_address"
                                                    value={props.device?.ip_address ? props.device?.ip_address : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.ip_address &&
                                                    <p className='text-red text-xs'>{props.error.ip_address}</p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-nowrap items-center justify-between'>
                                                <div className='w-2/3 flex flex-nowrap items-center justify-start'>
                                                    <label className='w-1/3 text-base input-label-color p-2' htmlFor="remote_access_URL">Remote Access Enabled and URL</label>
                                                    <input
                                                        placeholder='URL'
                                                        className='p-1 w-2/3 mr-2 text-base input-color outline-none hide-input-background'
                                                        type="text"
                                                        name="remote_access_URL"
                                                        value={props.device?.remote_access_URL ? props.device?.remote_access_URL : ""}
                                                        disabled={true}
                                                        onChange={props.updateDevice} />
                                                    {
                                                        props.error && props.error.remote_access_URL &&
                                                        <p className='text-red text-xs'>{props.error.remote_access_URL}</p>

                                                    }
                                                </div>
                                                <div className="w-1/3">
                                                    {props.device?.remote_access_URL && props.device?.device_type === 'acurev' &&
                                                        <Link className="cursor-pointer underline text-[#007b4e]" target="_blank" to={`https://${props.device?.device_id}.accuenergy.io`}>
                                                            Remote Access
                                                        </Link>
                                                    }
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-1/5 text-base input-label-color' htmlFor="installed_by">Installed By</label>
                                                <input
                                                    placeholder='Installed By'
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="text"
                                                    name="installed_by"
                                                    value={props.device?.installed_by ? props.device?.installed_by : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.installed_by &&
                                                    <p className='text-red text-xs'>{props.error.installed_by}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-1/5 text-base input-label-color' htmlFor="installed_date">Install Date</label>
                                                <input
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="date"
                                                    name="installed_date"
                                                    value={props.device?.installed_date ? props.device?.installed_date.split("T")[0] : ''}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.installed_date &&
                                                    <p className='text-red text-xs'>{props.error.installed_date}</p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap w-full'>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-3/12 text-base input-label-color' htmlFor="meter_pwrd_by_breaker_no">Device Powered By</label>
                                                <input
                                                    placeholder='Device Powered By'
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="text"
                                                    name="meter_pwrd_by_breaker_no"
                                                    value={props.device?.meter_pwrd_by_breaker_no ? props.device?.meter_pwrd_by_breaker_no : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.meter_pwrd_by_breaker_no &&
                                                    <p className='text-red text-xs'>{props.error.meter_pwrd_by_breaker_no}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <div className='w-full flex flex-wrap items-center'>
                                                    <label className='mobile:w-1/2 tablet:w-3/12 text-base input-label-color' htmlFor="device_id">Serial Number</label>
                                                    <input
                                                        placeholder='Serial Number'
                                                        className='p-1 mobile:w-1/2 tablet:w-8/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                        type="text"
                                                        name="device_id"
                                                        value={props.device?.device_id ? props.device?.device_id : ""}
                                                        disabled={true}
                                                        onChange={props.updateDevice} />
                                                    {
                                                        props.error && props.error.device_id &&
                                                        <p className='text-red text-xs'>{props.error.device_id}</p>

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-nowrap items-center'>
                                                <label className='w-2/12 text-base input-label-color' htmlFor="mac_address">Mac Address</label>
                                                <input
                                                    placeholder='Mac Address'
                                                    className='p-1 w-full mr-2 text-base input-color outline-none hide-input-background p-2'
                                                    type="text"
                                                    name="mac_address" value={props.device?.mac_address ? props.device?.mac_address : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.mac_address &&
                                                    <p className='text-red text-xs'>{props.error.mac_address}</p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap'>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-3/12 text-base input-label-color' htmlFor="commissioned_by">Commissioned By</label>
                                                <input
                                                    placeholder='Commissioned By'
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="text"
                                                    name="commissioned_by"
                                                    value={props.device?.commissioned_by ? props.device?.commissioned_by : ""}
                                                    disabled={true}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.commissioned_by &&
                                                    <p className='text-red text-xs'>{props.error.commissioned_by}</p>

                                                }
                                            </div>
                                        </div>
                                        <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                            <div className='w-full flex flex-wrap items-center'>
                                                <label className='mobile:w-1/2 tablet:w-3/12 text-base input-label-color' htmlFor="commissioned_date">Commissioned Date</label>
                                                <input
                                                    className='p-1 mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="date"
                                                    name="commissioned_date"
                                                    disabled={true}
                                                    value={props.device?.commissioned_date ? props.device?.commissioned_date.split("T")[0] : ''}
                                                    onChange={props.updateDevice} />
                                                {
                                                    props.error && props.error.commissioned_date &&
                                                    <p className='text-red text-xs'>{props.error.commissioned_date}</p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div >
        </div>
    )
}


export default DeviceInfo;